import {BoatType} from './BoatType';
import {MachineConfiguration} from './MachineConfiguration';

export enum MachineType {
    RP3_S = 'RP3_S',
    RP3_T = 'RP3_T',
    RP3_AQUA = 'RP3_AQUA',

    CONCEPT2_PM5 = 'CONCEPT2_PM5',

    // This is used when the machine type is not known during the import process.
    UNKNOWN = 'UNKNOWN',
}

export function machineTypesContainRp3OrEmpty(machineConfigurations: MachineConfiguration[]): boolean {
    return (
        machineConfigurations.length === 0 ||
        machineConfigurations
            .map((machineConfiguration) => machineConfiguration.machine_type)
            .some((type) => {
                return type === MachineType.RP3_S || type === MachineType.RP3_T || type === MachineType.RP3_AQUA;
            })
    );
}

export function toMachineTypeDisplayName(machineType: MachineType): string {
    switch (machineType) {
        case MachineType.RP3_S:
            return 'RP3 S';
        case MachineType.RP3_T:
            return 'RP3 T';
        case MachineType.RP3_AQUA:
            return 'RP3 Aqua';
        case MachineType.CONCEPT2_PM5:
            return 'Concept2';
        case MachineType.UNKNOWN:
            return 'Unknown machine type';
    }
}
